export default {
  name: 'desktop-sidebar-container',
};
